import { useState, useEffect, useMemo } from 'react';
import { getContext } from '@/context';
import {
  TOUCHPOINT_POLL_INTERVAL_MS,
  TOUCHPOINT_MAX_ATTEMPTS,
} from '@/consts/touchpoint';

export const GENAI_STUDIO_TOUCHPOINT = 'com.picsart.apps.genai';

const readTouchpoint = (): string | null => {
  try {
    const headers = getContext().utils.api.getHeaders();
    return headers?.['x-touchpoint-referrer'] ?? null;
  } catch {
    return null;
  }
};

const isWebGenaiStudio =
  typeof window !== 'undefined' &&
  window.location.href.toLowerCase().includes('genaistudio');

export const useTouchpoint = () => {
  const [touchpoint, setTouchpoint] = useState<string | null>(readTouchpoint);

  useEffect(() => {
    if (touchpoint !== null) return;

    let attempt = 0;
    const id = setInterval(() => {
      const value = readTouchpoint();
      attempt += 1;
      if (value !== null || attempt >= TOUCHPOINT_MAX_ATTEMPTS) {
        setTouchpoint(value);
        clearInterval(id);
      }
    }, TOUCHPOINT_POLL_INTERVAL_MS);

    return () => clearInterval(id);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps -- only poll on mount when initial read returned null

  return useMemo(() => {
    const isGenaiStudioTouchpoint = touchpoint === GENAI_STUDIO_TOUCHPOINT;
    return {
      touchpoint,
      isGenaiStudioTouchpoint,
      isWebGenaiStudio,
      showUserMenu: isGenaiStudioTouchpoint || isWebGenaiStudio,
    };
  }, [touchpoint]);
};
